import React from 'react'
import { Layout, Showcase, SectionTitle, Header } from '../../../../components'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        state="develop"
        slug={data.slug + '/develop/'}
        title={data.title}
      />
      <Layout
        inProgress={true}
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title="Default"
          text={
            <p>
              The Default Tooltip is triggered on tap, click or keyboard focus.
              It is dismissed by clicking the Close action or moving focus out
              of the tooltip. Change the modifier on the{' '}
              <span class="inline__code">c-tooltip--top</span> class to
              determine placement (--right, --bottom, --left). Remove the{' '}
              <span class="inline__code">{'<h1>'}</span> if no Title is needed.
            </p>
          }
          code={code.tooltipDefault}
        >
          <div class="c-tooltip c-tooltip--top">
            <div class="c-tooltip__header">
              <h1 class="c-tooltip__title">Title</h1>
              <button class="c-tooltip__close-button">
                Close{' '}
                <i class="c-tooltip__close-button-icon icon icon--close"></i>
              </button>
            </div>
            <div class="c-tooltip__content">
              I provide additional information that is nice to have but that you
              don't need to complete your task.
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Hover"
          text={
            <div>
              <p>
                The Hover Tooltip is triggered on mouseover and dismissed on
                mouse away on non-touchscreen devices. Use a media-query to
                determine device type.{' '}
              </p>

              <p>
                Change the modifier on the{' '}
                <span class="inline__code">c-tooltip--top</span> class to
                determine placement (--right, --bottom, --left). Remove the{' '}
                <span class="inline__code">{'<h1>'}</span> if no Title is
                needed.
              </p>
            </div>
          }
          code={code.tooltipHover}
        >
          <div class="c-tooltip c-tooltip--top">
            <div class="c-tooltip__header">
              <h1 class="c-tooltip__title">Title</h1>
            </div>
            <div class="c-tooltip__content">
              I provide additional information that is nice to have but that you
              don't need to complete your task.
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Icon"
          text={
            <p>
              The Icon Tooltip is triggered on mouseover and dismissed on mouse
              away. Change the modifier on the{' '}
              <span class="inline__code">c-tooltip--top</span> class to
              determine placement (--right, --bottom, --left).
            </p>
          }
          code={code.tooltipIcon}
        >
          <div class="c-tooltip--icon c-tooltip--top">
            <div class="c-tooltip__content">Additional information</div>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  tooltipDefault: `<div class="c-tooltip c-tooltip--top">
  <div class="c-tooltip__header">
    <h1 class="c-tooltip__title">Title</h1>
    <button class="c-tooltip__close-button">
      Close <i class="c-tooltip__close-button-icon icon icon--close"></i>
    </button>
  </div>
  <div class="c-tooltip__content">
  I provide additional information that is nice to have but that you don't need to complete your task.
  </div>
</div>`,
  tooltipHover: `<div class="c-tooltip c-tooltip--top">
  <div class="c-tooltip__header">
    <h1 class="c-tooltip__title">Title</h1>        
  </div>
  <div class="c-tooltip__content">
    I provide additional information that is nice to have but that you don't need to complete your task.
  </div>
</div>`,
  tooltipIcon: `<div class="c-tooltip--icon c-tooltip--top">
  <div class="c-tooltip__content">
    Additional information
  </div>
</div>`,
}
